module.exports = __webpack_public_path__ + "img/计算文本相似度.7eca9276.png";